import { assertUnreachable } from '@sgme/fp';

import { mapToCallOrder } from '@/domain/FxOrder/Call/CallOrder.utils.ts';
import { mapToFalcon } from '@/domain/FxOrder/Falcon/Falcon.utils.ts';
import { mapToFixing } from '@/domain/FxOrder/Fixing/Fixing.utils.ts';
import { mapToNightjar } from '@/domain/FxOrder/Nightjar/Nightjar.utils.ts';
import { mapToStopLoss } from '@/domain/FxOrder/StopLoss/StopLoss.utils.ts';
import { mapToTakeProfit } from '@/domain/FxOrder/TakeProfit/TakeProfit.utils.ts';
import { mapToTwap } from '@/domain/FxOrder/Twap/Twap.utils.ts';
import type { WorkspaceForex } from '@/domain/WorkspaceForex/WorkspaceForex.ts';

export const mapToOrderTile = (savedTile: WorkspaceForex['products']['order'][number]) => {
  switch (savedTile.type) {
    case 'StopLossOrder':
      return mapToStopLoss(savedTile);
    case 'TakeProfitOrder':
      return mapToTakeProfit(savedTile);
    case 'FixingOrder':
      return mapToFixing(savedTile);
    case 'CallOrder':
      return mapToCallOrder(savedTile);
    case 'Twap+Order':
      return mapToTwap(savedTile);
    case 'FalconOrder':
      return mapToFalcon(savedTile);
    case 'NightjarOrder':
      return mapToNightjar(savedTile);
    default:
      return assertUnreachable(savedTile, 'Unknown order type');
  }
};
